import { Link } from "react-router-dom";
import { Terminal } from "lucide-react";

export default function AuthLayout({ step, title, subtitle, children }) {
  return (
    <div className="relative min-h-screen bg-[#050505] text-white overflow-hidden">
      <div className="grid-bg absolute inset-0 pointer-events-none opacity-30" />

      <div className="relative grid grid-cols-1 lg:grid-cols-12 min-h-screen">
        {/* Left · brand + copy */}
        <aside className="lg:col-span-5 border-b lg:border-b-0 lg:border-r border-neutral-900 p-8 md:p-12 flex flex-col justify-between">
          <Link to="/" className="flex items-center gap-3" data-testid="auth-brand">
            <div className="h-8 w-8 bg-[#E2FF54] flex items-center justify-center">
              <Terminal size={16} className="text-black" strokeWidth={2.5} />
            </div>
            <div className="flex flex-col leading-tight">
              <span className="mono text-[10px] uppercase tracking-[0.3em] text-neutral-500">
                utility
              </span>
              <span className="mono text-sm font-semibold text-white tracking-wider">
                FOP.REWRITE
              </span>
            </div>
          </Link>

          <div className="my-10">
            <p className="mono text-[11px] uppercase tracking-[0.32em] text-[#E2FF54]">
              // client portal
            </p>
            <h1 className="display text-4xl md:text-5xl font-bold uppercase leading-[0.95] mt-4">
              Stamp PDFs.
              <br />
              <span className="text-[#E2FF54]">Track every</span>
              <br />
              <span className="text-neutral-500">rewrite.</span>
            </h1>
            <p className="mono text-xs text-neutral-500 mt-6 max-w-md leading-relaxed">
              A private workspace where every rewrite is logged with timestamp,
              size, and filename — accessible from your portal.
            </p>
          </div>

          <div className="mono text-[10px] uppercase tracking-[0.3em] text-neutral-700">
            v2.3.0 · pikepdf backend
          </div>
        </aside>

        {/* Right · form */}
        <section className="lg:col-span-7 p-8 md:p-14 flex items-center">
          <div className="w-full max-w-md">
            {step && (
              <p className="mono text-[11px] uppercase tracking-[0.28em] text-neutral-500 mb-3">
                {step}
              </p>
            )}
            <h2 className="display text-3xl md:text-4xl font-bold text-white leading-tight">
              {title}
            </h2>
            {subtitle && (
              <p className="mono text-sm text-neutral-400 mt-3 leading-relaxed">
                {subtitle}
              </p>
            )}
            <div className="mt-10">{children}</div>
          </div>
        </section>
      </div>
    </div>
  );
}
